import React, { useState, useEffect } from 'react';
import './Footer.css';
import logoFooter from '../../assets/img/Bdue_logo_400.png'
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import logo from '../../assets/img/Group 1000002447.svg'
import { Link } from 'react-router-dom';
import phoneIcon from '../../assets/img/phone-solid-full 1.svg'
import emailIcon from '../../assets/img/envelope-solid-full 1.svg'
import footerLogos from '../../assets/img/footerlogos-waraq.svg'
const Footer = () => {
  return (
    <>
      <footer>

        <div className="footer-col first-col">
          <div className='image-logo'>
            <a href="https://bdue.de/der-bdue"
              target="_blank"
              rel="noopener noreferrer">

              <img style={{ width: '150px', height: '150px' }} src={footerLogos} alt='image not found' />
            </a>
          </div>

          <div className="contact-details">
            <div className="contact-info">
              <img src={phoneIcon} />
              <span>+49 151 74578596</span>
            </div>
            <div className="contact-info">
              <img src={emailIcon} />
              <a href="mailto:translate@wa-raq.de">translate@wa-raq.de</a>
            </div>
            <div className="contact-info">

              <a href="https://www.linkedin.com/company/waraq-translations/"
                target="_blank"
                rel="noopener noreferrer">

                <LinkedInIcon style={{ fontSize: '13px' }} />
              </a>
            </div>
          </div>
        </div>
        <div className="footer-col">
          <h3>Waraq Translations:</h3>

          <Link style={{ cursor: 'pointer', color: '#000', fontSize: '10px', fontWeight: '400', margin: '5px 0px' }} to="/LegalAndNotice">Legal Notice (Impressum)  </Link>

          <Link style={{ cursor: 'pointer', color: '#000', fontSize: '10px', fontWeight: '400', marginTop: '23px' }} to="/PrivacyAndPolicy">Privacy Policy (Datenschutzerklärung)</Link>
        </div>
        <div className="footer-col services">
          <h3>Member of the:</h3>
          <a style={{ fontWeight: '400', margin: '10px 0', fontSize: '10px' }}>
            <b>Bundesverband der Dolmetscher und Übersetzer e.V. (BDÜ) </b>
            <br /> (Federal Association of Interpreters and Translators, Germany)</a>
        </div>




        <div className="footer-col">
          <p className="about-text">
            <strong>About us:</strong> We deliver high-quality, culturally nuanced translations in German, English, and Arabic.
            From certified documents to business content, our native-speaking linguists ensure accuracy and impact across languages.
          </p>

        </div>


      </footer>



      <div className="footer_under">
        <div className="footer-content">
          Copyright © 2026 Waraq Translation Agency. All Rights Reserved.
        </div>
      </div>
    </>

  );
};

export default Footer;
